import './css/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { App } from './components/App';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { ErrorBoundaryWrapper } from './components/ErrorBoundary';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { localStorageHelper } from './services/helpers/localStorageHelper';
import { Provider } from 'react-redux';
import { recaptchaPublicKey } from 'src/app-config';
import { store } from 'src/store';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root') as Element;

localStorageHelper.RemoveLegacyAuthTokens();

createRoot(container).render(
    <BrowserRouter>
        <style>
            {`
               .grecaptcha-badge {
                    bottom: -999px !important;
                }
            `}
        </style>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaPublicKey}>
            <Provider store={store}>
                <ErrorBoundaryWrapper>
                    <App />
                </ErrorBoundaryWrapper>
            </Provider>
        </GoogleReCaptchaProvider>
    </BrowserRouter>
)

serviceWorker.unregister();
